// extracted by mini-css-extract-plugin
export default {"wrapper":"BackToTopBtn_wrapper__psw39","arrow-up":"BackToTopBtn_arrow-up__ocCGV"};